/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="login.model.ts" />

module Eseebase {
    export class LoginController implements angular.IController{
        public login: LoginModel;
        public spin: boolean;
        public accessDenied: boolean;
        public forgotPassword: boolean;
        public passwordIsSent: boolean;
        $onInit = () => { };

        constructor(private $scope: ng.IScope,
            private userService: UserService,
            private cookiesService: CookiesService,
            private $rootScope: ng.IRootScopeService,
            private $route: any,
            private textService: TextService,
            private $mdDialog: any

        ) {
            this.login = new LoginModel();
            this.spin = false;
            this.accessDenied = this.getParameterByName("accessDenied", null) == "true";
            this.$rootScope.$broadcast('$hideLoader');
        }

        public authenticate()
        {
            var sender = angular.element('a.login');
            $(sender).addClass('thinking');
            var vm = this;
            this.spin = true;
            this.userService.authenticate(this.login).then(
                (data: any) => {
                    if (data != null && data.data != null && (<any>data).data.access_token != null) {
                        vm.loginSucceeded(data.data, sender);
                    }
                    else {
                        vm.loginFailed(sender);
                    }
                }, () => vm.loginFailed(sender));
        }

        public loginSucceeded(data, sender) {
            var vm = this;
            this.login.accessToken = data.access_token;
            this.login.refreshToken = data.refresh_token;
            this.login.failed = false;
            this.userService.saveAccessToken(this.login, this.login.rememberMe);
            this.cookiesService.deleteCookie('company');
            this.cookiesService.deleteCookie('modelFilter');
            this.userService.getUser().then((data: UserModel) => {
                if (data.defaultLanguage != null) {
                    vm.cookiesService.createCookie('currentLanguage', data.defaultLanguage, vm.login.rememberMe ? 60 * 24 * 365 * 5 : 0);
                }
                var redirectUrl = vm.getParameterByName('redirectUrl', null);
                vm.$rootScope.$broadcast('login');
                if (!redirectUrl) {
                    window.location.href = '/';
                }
                else {
                    window.location.href = redirectUrl;
                }
            }, () => vm.loginFailed(sender));
        }

        public loginFailed(sender)
        {
            $(sender).removeClass('thinking');
            this.login.failed = true;
            this.spin = false;
        }

        private getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        public goToForgotPassword() {
            this.forgotPassword = true;
            this.passwordIsSent = false;
        }

        public goToLogin() {
            this.forgotPassword = false;
            this.passwordIsSent = false;
            this.login.failed = false;
            this.spin = false;
        }

        public sendPassword(event) {
            var vm = this;
            var sender = angular.element('a.login');
            $(sender).addClass('thinking');
            this.spin = true;
            this.userService.sendPassword(this.login.email).then(() => {
                vm.passwordIsSent = true;
                $(sender).removeClass('thinking');
                vm.spin = false;
            }, () => {
                $(sender).removeClass('thinking');
                vm.spin = false;
                vm.showAlert('eseeBASE', 'An error has occured. Please, try again later.');
            });
        }

        private showAlert(title: string, message: string) {
            this.$mdDialog.show(
                this.$mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(title)
                    .textContent(message)
                    .ok('OK')
            );
        }

    }

    LoginController.$inject = ['$scope', 'UserService', 'CookiesService', '$rootScope', '$route', 'TextService', '$mdDialog'];

    angular
        .module('eseebase')
        .controller('LoginController', LoginController);
}
